import { connect } from 'react-redux';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { ANALYTICS_EVENTS } from 'src/app/analytics/analyticsEvents';
import { segmentAnalyticsEvent, segmentTrack } from 'src/app/state/actions';
import { isLoggedIn } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';

import Renderer from '.';

const mapStateToProps = (state: RootState) => ({
  loggedIn: isLoggedIn(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  expandCallback: (questions, index) =>
    dispatch(segmentAnalyticsEvent(`${ANALYTICS_EVENTS.faqPrefix}${questions[index].question.props.children}`)),
  dispatchSegmentTrack: (event: UnifiedEvent, payload) => dispatch(segmentTrack(event, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Renderer);
